






























































































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { useUserStore } from "@/shared/store/user";
import * as RouteNames from "@/employee/route-names";
import { useThemeStore } from "@/shared/store/theme";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import ManagedExpenseTable from "@/employee/components/landing-pages/hsabank/expense/ManagedExpenseTable.vue";
import TalonClaimsTable from "@/employee/components/landing-pages/hsabank/expense/TalonClaimsTable.vue";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import ManagedExpenseFilters from "@/employee/components/landing-pages/hsabank/expense/ManagedExpenseFilters.vue";
import {
  FetchState,
  HsabAccountNametag,
  HsabExpenseEvidenceShoeboxModalSource,
  HsabExpenseFormMode,
  HsabSsoDestination,
  ManagedExpenseFilterType
} from "@/shared/types";
import HsabExpenseEvidenceShoeboxModal from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidenceShoeboxModal.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { useDistributionSchedulesStore } from "@/shared/store/distributionSchedules";
import { useHsabEnrollmentStore } from "@/employee/store/hsabEnrollment";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import moment from "moment";
import _ from "lodash";
import { formatCurrency } from "@/shared/currency";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { useHsabExpenseEvidenceShoeboxStore } from "@/employee/store/hsabExpenseEvidenceShoebox";
import RecurringExpenseTemplateModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/RecurringExpenseTemplateModal.vue";


@Component({
  components: {
    RecurringExpenseTemplateModal,
    SsoDeepLink,
    HsabExpenseEvidenceShoeboxModal,
    ManagedExpenseFilters,
    ManagedExpenseTable,
    TalonClaimsTable,
  }
})
export default class HsabExpenseManagement extends Vue {
  hsabExpense = useHsabExpenseStore();
  userStore = useUserStore();
  hsabAccountsStore = useHsabAccountsStore();
  RouteNames = RouteNames;
  themeStore = useThemeStore();
  contactInfoStore = useContactInfoStore();
  managedExpensesStore = useManagedExpenseStore();
  flagStore = useFeatureFlagStore();
  distributionSchedulesStore = useDistributionSchedulesStore();
  hsabEnrollmentStore = useHsabEnrollmentStore();
  balanceStore = useHsaDailyBalanceStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  formatCurrency = formatCurrency;
  ssoDestination = HsabSsoDestination;
  ManagedExpenseFilterType = ManagedExpenseFilterType;
  shoeboxStore = useHsabExpenseEvidenceShoeboxStore();

  @Prop({ default: () => ManagedExpenseFilterType.MyExpenses })
  filter: ManagedExpenseFilterType;

  @Watch("$props.filter")
  onFilterChange () {
    this.managedExpensesStore.setBaseFilterType(this.filter);
  }

  mounted () {
    this.contactInfoStore.getContactInformation();
    this.managedExpensesStore.loadManagedExpensesByPage(1, this.filter);
    this.distributionSchedulesStore.getDistributionSchedules();
    this.balanceStore.loadInstantBalance({ force: true });
    this.balanceStore.loadBalanceOnFile();
    this.loadClaimExchangeSettings();
    this.hsabExpense.loadExpenseReimburseMeLimit();
  }

  get areFlagsLoaded () {
    return this.flagStore.featureFlagsAvailable;
  }

  get shouldCheckHealthcareClaimSettings () {
    return this.flagStore.flags.bend20914DeepLinkForManageHealthcareClaims;
  }

  get showViewUploadedReceiptsButton () {
    return !this.flagStore.flags.bend24844UploadShoeboxReceipts && this.shoeboxStore.totalItemCount > 0;
  }

  get showUploadShoeboxButton () {
    return this.flagStore.flags.bend24844UploadShoeboxReceipts;
  }

  get showManageHealthcareClaims () {
    return this.hsabEnrollmentStore.userCanManageCarrierClaims;
  }

  get disableManageHealthcareClaimsDeepLink () {
    return this.flagStore.flags.bend20914DeepLinkForManageHealthcareClaims && this.hsabEnrollmentStore.employerSettings === null
        && this.hsabEnrollmentStore.employerSettingsFetchState === FetchState.Failed;
  }

  get showExportAllExpensesButton () {
    return this.flagStore.flags.bend21900ExportAllExpenses;
  }

  get showExportFilteredExpensesButton () {
    return this.flagStore.flags.bend21900ExportFilteredExpenses;
  }

  loadClaimExchangeSettings () {
    if (this.shouldCheckHealthcareClaimSettings) {
      this.hsabEnrollmentStore.loadHsabEnrollmentEmployerSettings();
    }
  }

  addExpenseAction (event: any) {
    this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.createOrEdit);
  }

 get showPlaceCommuterOrderButton (): boolean {
    const planTypesAndSubtypes = this.hsabAccountsStore.allActivePlanTypesAndSubTypes;
    return planTypesAndSubtypes
      && planTypesAndSubtypes.hasSmartCommutePlan === true;
  }

  get showManageDistributionsButton (): boolean {
    return this.distributionSchedulesStore.schedulesLoaded && this.distributionSchedulesStore.hasSchedules;
  }
  get cashAccountBalanceLoaded (): boolean {
    return this.balanceStore.balanceOnFileLoaded && this.balanceStore.balanceOnFileLoaded;
  }

  get showCashBalance (): boolean {
    return this.hsabAccountsStore.userHasAnyActiveAccount;
  }

  get isHsaOnly (): boolean {
    return this.hsabAccountsStore.isHsaOnly;
  }

  formatPlanName (plan: HsabAccountNametag) {
    if (plan.bankAccountType === "hsa") {
      return "Health Savings Account (Cash Account)";
    }
    return `${plan.accountName} (${moment(plan.startDate).format("YYYY")})`;
  }

  get activePlans () {
    return _.orderBy(this.hsabAccountsStore.allActiveHsabAccounts, [i => i.bankAccountType, i => i.accountName], [ "asc", "asc" ]);
  }

  get cashAccountBalance (): number {
    return this.hsabExpenseFormStore.cashAccountBalance;
  }

  onManagedDistributionsActionClicked () {
    const btn = this.$refs.btnManagedDistributions as HTMLElement;
    btn.click();
  }

  onPlaceCommuterOrderActionClicked () {
    const btn = this.$refs.btnPlaceCommuterOrder as HTMLElement;
    btn.click();
  }

  onManageHealthcareClaimsClicked () {
    const btn = this.$refs.btnManageHealthcareClaims as HTMLElement;
    btn.click();
  }

  onOpenShoeboxModalClicked () {
    this.shoeboxStore.openShoeboxModal(HsabExpenseEvidenceShoeboxModalSource.expenseManagement);
  }

  onExportAllExpensesClicked () {
    this.managedExpensesStore.exportAllManagedExpenses();
  }

  onExportExpensesWithCurrentFiltersClicked () {
    this.managedExpensesStore.exportCurrentlyFilteredManagedExpenses();
  }
}
